import React from 'react';

import BaseAction from './action/baseAction';
import { CHARGER_TASK_STATUS_ACTION_MAP } from '../../constants/chargerTask';

const defaultMaker = () => [];

export const makeTaskActions = (task, userPermissions) => {
  const makeActions = CHARGER_TASK_STATUS_ACTION_MAP[task.status] || defaultMaker;

  return makeActions(userPermissions).map(
    (action) => (
      <BaseAction
        key={action}
        task={task}
        action={action}
      />
    ),
  );
};
